import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../../button";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { CustomMultiSelect } from "../../../../common/custom-form/custom-multi-select.component";

const options = [
    { value: 'apple', label: 'Apple' },
    { value: 'banana', label: 'Banana' },
    { value: 'orange', label: 'Orange' },
    { value: 'pear', label: 'Pear' },
  ];

export class ManageUserRoleModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show}=this.state;

    return(
      <>

    
      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="user-pen-light" iconSize="17px" customClassName="header-filter-button" labelName={this.props.labelName}/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit User Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                 <InputField label="ROLE NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                 <div className="multi-select-component">
                    <label>FUNCTIONALITY/PAGE</label>                  
                    <CustomMultiSelect options={options}/>
                 </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>ADD</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
